<template>
  <div id="container">
    <v-container wrap>
      <v-dialog v-model="enable" max-width="500" persistent>
        <v-card>
          <v-card-text style="text-align: center">
            <div
              class="mb-4"
              :style="{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }"
            >
              <div
                :style="{
                  borderRadius: '50%',
                  backgroundColor: '#fbdfde',
                  height: '65px',
                  width: '65px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '8px',
                }"
              >
                <v-icon large color="red">warning</v-icon>
              </div>
            </div>
            <p style="font-size: 1.5rem; font-weight: bold">
              ¿Estás seguro que deseas actualizar los datos de este horario?
            </p>
            <p style="color: #777">
              Al actualizar este horario, todos los colaboradores se verán
              afectados respecto a los datos que hayas modificado.
            </p>
          </v-card-text>
          <v-card-actions d-flex style="justify-content: center">
            <v-btn block depressed @click="cancel">No, Cancelar</v-btn>
            <v-btn
              block
              color="#ef565c"
              style="color: #fff"
              depressed
              @click="ok"
            >
              Sí, guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      enable: this.value,
    };
  },
  watch: {
    value() {
      this.enable = this.value;
    },
  },
  methods: {
    cancel() {
      this.$emit("input", !this.value);
      this.$emit("desition", false);
    },
    ok() {
      this.$emit("input", !this.value);
      this.$emit("desition", true);
    },
  },
};
</script>

<style>
</style>
